import { styled } from '@mui/material/styles';
import MuiLink from '@mui/material/Link';
import Box from '@mui/material/Box';

export const DownloadButton = styled(MuiLink)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  gap: theme.spacing(1),
  cursor: 'pointer',
}));

export const FeedbackToast = styled(Box)(({ theme }) => ({
  ...theme.typography.body2B,
  backgroundColor: theme.palette.colored.purple,
  color: theme.palette.neutrals.beige1,
  borderRadius: 8,
  boxShadow: '4px 4px 2px rgba(0,0,0,0.1)',
  padding: '10px 17px',
  width: 280,
  textAlign: 'center',
}));
